import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.less';
import ModalContainer from 'components/Common/ModalContainer';
import FMPersonalDetailsCard from '../FMPersonalDetailsCard/FMPersonalDetailsCard';
import StyledButton from 'components/Common/Buttons/StyledButton';
import { useHubAccountConfirmation } from 'modules/client/idVerification/useHubAccountConfirmation';
import { useHistory } from 'react-router-dom';
import { ROUTING } from 'config';

const AlreadyHaveFMAccountModal = ({ isOpen, onModalClose, rows }) => {
  const history = useHistory();
  const { confirmHubAccountExistence, isLoading } = useHubAccountConfirmation();

  const handleConfirm = async () => {
    try {
      await confirmHubAccountExistence();

      history.push(ROUTING.ID_VERIFICATION_OTP);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <ModalContainer
      className={styles.modal}
      isOpen={isOpen}
      onCancel={onModalClose}
      footerControls={<></>}
      title=" "
    >
      <div className={styles.title}>
        Hey, it looks like you might already have a Fusion Markets account
      </div>
      <div className={styles.subTitle}>
        The good news is that you can use this information to complete your
        access to the Fusion Partners portal.
      </div>

      <div className={styles.personalDetails}>
        <FMPersonalDetailsCard rows={rows} />
      </div>

      <div className={styles.footer}>
        <StyledButton
          className={styles.link}
          type="text"
          text="Not your personal details?"
        />

        <div className={styles.btnSubWrapper}>
          <StyledButton
            onClick={onModalClose}
            className={styles.cancelBtn}
            type="text"
            text="Cancel"
          />
          <StyledButton
            type="primary"
            text="Yes, I confirm"
            onClick={handleConfirm}
            loading={isLoading}
          />
        </div>
      </div>
    </ModalContainer>
  );
};

AlreadyHaveFMAccountModal.propTypes = {
  isOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

export default AlreadyHaveFMAccountModal;
